<template>
  <div :class="_class">
    <cat-skip-link
      :link-text="resolveTxt('skin.skip.to.content', 'Skip to main content')"
      link="#landing-page-main"
    ></cat-skip-link>

    <!--<cat-language-selector />-->

    <!--<a class="icon-compass page-finder open-finder" data-tooltip="Find a page or service" v-on:click="toggleMenu">Menu</a>-->
    <!--<cat-nav v-on:nav-close="toggleMenu" :open="drawer"><slot name="mainmenu"></slot></cat-nav>-->
    <cat-background />

    <cat-header :catalyst-api="catalyst">
      <template #header-controls>
        <cat-account
          :user="user"
          :organisation-identifier="organisationIdentifier"
        ></cat-account>
      </template>
    </cat-header>

    <div class="landing-page-main-menu" :class="mainMenuClass">
      <div class="grid-container">
        <div class="grid-x ptn pbn">
          <slot name="mainmenu"></slot>
        </div>
      </div>
    </div>
    <!-- <div class="nav-bar filled pattern"> -->
    <div
      id="landing-page-main"
      tabindex="-1"
      role="main"
      :aria-label="
        resolveTxt('skin.main.landing.content', 'Landing Page Main Content')
      "
      class="landing-page-main-content"
      :class="mainContentClass"
    >
      <div class="grid-container">
        <div class="grid-x grid-margin-x">
          <div class="small-12 medium-6 cell">
            <cat-cms-content
              v-if="_locations.indexOf('landing-1') >= 0"
              location="landing-1"
              :viewtree="viewtree"
            ></cat-cms-content>
            <div
              v-else
              v-html="
                resolveTxt('skin.main.landing.landing1', 'Welcome to Verne')
              "
            ></div>
          </div>
          <div class="small-12 medium-6 cell">
            <cat-cms-content
              v-if="_locations.indexOf('landing-2') >= 0"
              location="landing-2"
              :viewtree="viewtree"
            >
            </cat-cms-content>
            <div
              v-else
              v-html="resolveTxt('skin.main.landing.landing2', '')"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <div
      id="maincontent"
      role="main"
      :aria-label="resolveTxt('skin.main.content', 'Main Content')"
    >
      <div class="grid-container">
        <div class="grid-x grid-margin-x">
          <div class="small-12 cell">
            <div class="main-content">
              <div class="grid-x">
                <cat-cms-content
                  v-if="_locations.indexOf('landing-3') >= 0"
                  location="landing-3"
                  :viewtree="viewtree"
                />
                <slot v-else name="main_content"></slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <cat-page-help
      :url="helpUrl"
      :open="helpDrawer"
      :source-id="helpSourceId"
      :title="helpSourceTitle"
      :section-help="sectionHelp"
      show-tooltip
      @ui-close="closeHelp(viewtree.helpUrl)"
    />
    <cat-footer :content="footerContent" class="footerFrame" />
    <cat-throbber />
  </div>
</template>

<script lang="ts">
import { defineComponent, inject } from "vue";
import CatSkipLink from "@/components/catSkipLink/catSkipLink.vue";
import CatBtn from "@/components/catBtn/catBtn.vue";
import CatAccount from "../catAccount/catAccount.vue";
import CatFooter from "./footer.vue";
import CatPageHelp from "./catPageHelp.vue";
import CatCmsContent from "./catCmsContent.vue";
import CatThrobber from "./throbber.vue";
import CatBackground from "./background-layer.vue";
import CatHeader from "./header.vue";
import PageHelpMixin from "./pageHelpMixin";
import { defaultResolveTxt } from "@/components/field-element";

export default defineComponent({
  setup() {
    // Inject the global value
    const resolveTxt = inject("resolveTxt", defaultResolveTxt);

    return {
      resolveTxt
    };
  },
  name: "CatLandingPage",
  components: {
    CatCmsContent,
    CatSkipLink,
    CatAccount,
    CatFooter,
    // CatNav,
    CatPageHelp,
    CatBackground,
    CatThrobber,
    // CatLanguageSelector,
    CatHeader
  },
  mixins: [PageHelpMixin],
  props: {
    viewtree: {
      type: Object,
      default: () => ({})
    },
    // Pass in the Catalyst API so we can replace it in unit tests
    catalystApi: {
      type: Object,
      default: window["Catalyst"]
    },
    mainContentClass: {
      type: String,
      default: " nav-bar filled invert-text pattern "
    },
    mainMenuClass: {
      type: String,
      default: " nav-bar filled invert-text pattern "
    }
  },
  data: function () {
    return {
      helpUrl: this.viewtree.helpUrl,
      drawer: false,
      user: this.viewtree.usr,
      organisationIdentifier: this.viewtree.organisationIdentifier,
      service: this.viewtree.svc,
      additionalClasses: [],
      catalyst: this.catalystApi || window["Catalyst"],
      footerContent: this.viewtree.footerContent
    };
  },
  methods: {
    toggleMenu: function (evt) {
      this.drawer = !this.drawer;
    },
    addContentClass: function (classname: never) {
      if (this.additionalClasses.indexOf(classname) == -1) {
        this.additionalClasses.push(classname);
      }
    }
  },
  computed: {
    _locations: function () {
      let arr = [];
      for (let n in this.viewtree) {
        //TODO this is in the wrong layer
        let node = this.viewtree[n];
        if (node && node.kv && node.kv["location-name"]) {
          arr.push(<never>node.kv["location-name"]);
        }
      }
      return arr;
    },
    _class: function () {
      return {
        "cat-layout-landing": true,
        "app-content": true,
        "logged-in": !this.viewtree.usr.guest,
        "not-logged-in": this.viewtree.usr.guest
      };
    }
  },
  mounted: function () {
    if (
      navigator.userAgent.indexOf("MSIE") !== -1 ||
      navigator.appVersion.indexOf("Trident/") > -1
    ) {
      /* Microsoft Internet Explorer detected in. */
      document.querySelector("body").classList.add("if-ie");
    }

    this.initPageHelp(this.viewtree.helpUrl);
  },

  provide: function () {
    return {
      suppressExternalHelp: this.service.suppressExternalHelp,
      addContentClass: this.addContentClass
    };
  }
});
</script>
